
// src/connects/user-settings-page.js

import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import actions from '../actions'
import combineHOC from '../helpers/combine-hoc'
import lifecycle from '../helpers/lifecycle'
import config from '../config'

export const mapStateToProps = (state)=> {
  return {
    user: state.user.current,
    name: state.userSettings.name,
    active: state.userSettings.active,
    access_token: state.sessions.access_token,
    blockUsers: state.block.users
  }
}

export const mapDispatchToProps = (dispatch)=> {
  return {
    onClose: ()=> dispatch(actions.closeUserSettingsPage()),
    willUnmount: ()=> dispatch(actions.closeUserSettingsPage())
  }
}

export const mergeProps = (stateProps, dispatchProps, ownProps)=> {
  return Object.assign({}, stateProps, dispatchProps, ownProps, {
    usersAdminUrl: `${config.baseUrl}v3/session/redirect?login=true&redirect_to=/v3/users&access_token=${stateProps.access_token}`,
  })
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  lifecycle,
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/user-settings-page.js